module.exports = __webpack_public_path__ + "img/Flag_of_Greenland.9a0c4f66.svg";